import React, { useEffect, useState } from "react"
import {
  Typography,
  Button,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
} from "@mui/material"
import { useNavigate } from "react-router-dom"
import api from "../utils/api"

export const DeleteEventForm = () => {
  const [events, setEvents] = useState([])
  const [selectedEvent, setSelectedEvent] = useState("")
  const navigate = useNavigate()

  useEffect(() => {
    fetchEvents("/admin/events", setEvents)
  }, [])

  const fetchEvents = async (url: string, setter: any) => {
    try {
      const response = await api.get(url)
      const data = response.data
      setter(data)
    } catch (error) {
      console.error(`Error fetching data from ${url}:`, error)
    }
  }

  const handleSubmit = async () => {
    if (!selectedEvent) {
      return
    }

    const confirmDelete = window.confirm(
      `Are you sure you want to delete this event?`
    )
    if (!confirmDelete) {
      return
    }

    try {
      await api.delete(`/admin/events/${selectedEvent}`)
      navigate("/admin/dashboard", {
        state: { notification: "Event successfully deleted!" },
      })
    } catch (error) {
      console.error("Error deleting event:", error)
    }
  }

  return (
    <>
      <Typography variant="h6" m={4}>
        Select Event to Delete
      </Typography>

      {/* Events Dropdown */}

      <FormControl fullWidth margin="normal" required>
        <InputLabel id="event-label">Event</InputLabel>
        <Select
          label="Event"
          labelId="event-label"
          value={selectedEvent}
          onChange={(e) => {
            setSelectedEvent(e.target.value)
          }}
        >
          {events && events.length > 0 ? (
            events.map((event: { name: string; id: string }) => (
              <MenuItem key={event.id} value={event.id}>
                {event.name}
              </MenuItem>
            ))
          ) : (
            <MenuItem value="">No events available</MenuItem>
          )}
        </Select>
      </FormControl>

      <Button
        variant="contained"
        color="primary"
        fullWidth
        onClick={handleSubmit}
      >
        Delete
      </Button>
    </>
  )
}
